export default __webpack_public_path__ + "static/media/newImg3.deb6a9d2.svg";